import { render, staticRenderFns } from "./_eventsList.vue?vue&type=template&id=1e959963&"
import script from "./_eventsList.vue?vue&type=script&lang=js&"
export * from "./_eventsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports